'use client'

import { ssrExchange, UrqlProvider } from '@urql/next'
import { useSession } from 'next-auth/react'
import { Suspense, useMemo } from 'react'
import { createUrqlClient } from '@/utils/urql'

function UrqlClientProvider({ children }: React.PropsWithChildren) {
    const sessionContext = useSession()
    const isAuthenticated =
        sessionContext.status === 'authenticated' ||
        sessionContext.status === 'loading'

    const sessionId = sessionContext.data?.user.sessionId

    const [client, ssr] = useMemo(() => {
        const ssrInternal = ssrExchange({
            isClient: typeof window !== 'undefined',
        })
        const clientInternal = createUrqlClient(ssrInternal, sessionContext)

        return [clientInternal, ssrInternal]
    }, [isAuthenticated, sessionId])

    return (
        <UrqlProvider client={client} ssr={ssr}>
            <Suspense fallback={null}>{children}</Suspense>
        </UrqlProvider>
    )
}

export { UrqlClientProvider }
